import { useTranslation } from "react-i18next";
import {
  FormSection,
  FormSectionStack,
  NumberField,
} from "@/features/admin/components";

/**
 * Paso 4 · Los puntos MLM: PV y CV, y nada más.
 *
 * ── SOLO dos campos (Anahí, 26-ago, segunda pasada) ─────────────────
 * "Aquí es PV (Point Value) y CV (Commission Value), que son la base
 * para el sistema multinivel." Salieron de este paso los puntos en
 * promoción, las cinco casillas del plan y los dos textos de membresía:
 * sus datos siguen viajando en el formulario —quitar el control no
 * borra lo guardado—, solo dejaron de editarse aquí.
 *
 * ── PV y CV son dos, no uno con un factor ───────────────────────────
 * El PV es `volumePoints`, el campo SUELTO del producto: es el que lee
 * el motor de comisiones —de él salen `Purchase.volumePoints` y la
 * regla 40/60— y el que el carrito compara contra el mínimo de un
 * paquete. El CV es `compensation.commissionPoints`, y es OTRO dato:
 * hay productos que dan puntos de rango y no reparten comisión, y al
 * revés. En el catálogo real, Sexto Elemento da 60 PV y 45 CV.
 *
 * ── Enteros, como el dinero ─────────────────────────────────────────
 * Los puntos se suman miles de veces al mes para decidir rangos y
 * comisiones; un decimal ahí acumula error hasta que el corte mensual
 * no cuadra. Es la misma razón por la que el dinero va en centavos.
 */
export function PointsStep() {
  const { t } = useTranslation();

  return (
    <FormSectionStack>
      <FormSection
        title={t("Puntos")}
        description={t("La base del sistema multinivel: lo que este producto aporta.")}
        columns={3}
        compact
      >
        <NumberField
          name="volumePoints"
          label={t("PV · puntos de volumen")}
          hint={t("Point Value: lo que suma al volumen de quien compra.")}
        />
        <NumberField
          name="compensation.commissionPoints"
          label={t("CV · volumen comisionable")}
          hint={t("Commission Value: puede diferir del PV.")}
        />
      </FormSection>
    </FormSectionStack>
  );
}
